import { Loader } from '@googlemaps/js-api-loader'

// Singleton Google Maps JS API Loader for the Admin app
// Usage:
//   await importPlaces(); // ensures Maps JS is loaded, then loads Places library
//   await importGeometry(); // loads geometry
//   await importDrawing(); // loads drawing

const apiKey: string = process.env.REACT_APP_GOOGLE_MAPS_KEY || ''

const loader = new Loader({
  apiKey,
  version: 'weekly',
  language: 'en',
})

let loadPromise: Promise<void> | null = null
let placesPromise: Promise<void> | null = null
let geometryPromise: Promise<void> | null = null
let drawingPromise: Promise<void> | null = null

export function loadGoogleMaps(): Promise<void> {
  if (!loadPromise) {
    loadPromise = (async () => {
      await loader.load()
    })()
  }
  return loadPromise!
}

export async function importPlaces(): Promise<void> {
  if (!placesPromise) {
    placesPromise = (async () => {
      await loadGoogleMaps()
      await loader.importLibrary('places')
    })()
  }
  return placesPromise
}

export async function importGeometry(): Promise<void> {
  if (!geometryPromise) {
    geometryPromise = (async () => {
      await loadGoogleMaps()
      await loader.importLibrary('geometry')
    })()
  }
  return geometryPromise
}

export async function importDrawing(): Promise<void> {
  if (!drawingPromise) {
    drawingPromise = (async () => {
      await loadGoogleMaps()
      await loader.importLibrary('drawing')
    })()
  }
  return drawingPromise
}

// Optional helper: returns true if Google Maps JS appears to be available
export function isGoogleMapsAvailable(): boolean {
  return typeof window !== 'undefined' && !!(window as any).google?.maps
}

